/**
 * PR-CWJ-03 — Unified Workspace UI
 *
 * Shared workspace state that binds Chat, Code, Cowork and Voice to a single
 * canonical taskId. This package is contract-level and does not perform real
 * provider calls, file mutation, or hidden recording.
 */
export class CwjWorkspaceError extends Error {
    constructor(message, code) {
        super(message);
        this.name = "CwjWorkspaceError";
        this.code = code;
    }
}
//# sourceMappingURL=types.js.map